module.exports = __webpack_public_path__ + "img/cloud-lightning-sun-2.9bb8eb3a.svg";